import cmsParser from 'Common/util/cmsParser';

import type { PageEntry, Node } from 'contensis-delivery-api';
import type { Props } from './TranscriptVideo';

export type PageData = {
    entry: PageEntry;
    ancestors: Node[];
};

const datamap = (data: PageData): Props => {
    const { entry, ancestors } = data;
    const { title, sys } = entry;

    return {
        breadcrumbs: cmsParser.breadcrumbs([...ancestors, { entry: { title: title }, id: sys.id }]),
        video: { transcriptEmbed: cmsParser.transcriptEmbed(entry) },
        heading: `${title} transcript`
    };
};

export default datamap;
